import axios from 'axios';
import {filter} from "../filter/filter";

const DATA_ATTR = 'data-troika-main';
const CLASS_PREFIX = 'troika-main';

const $container = document.querySelector(`[${DATA_ATTR}]`);

if ($container) troikaMain($container);

export function troikaMain($container) {

    const $templateTroikaItem = $container.querySelector(`[${DATA_ATTR}-template-troika-item]`);
    const $troikaListContainer = $container.querySelector(`[${DATA_ATTR}-troika-list]`);
    const $troikaFiltersContainer = $container.querySelector(`[${DATA_ATTR}-troika-filters]`);

    const troikaData = [
        { name: 'Тройка 1', roles: [{name: 'Клиент', is_busy: true}, {name: 'Интервизор', is_busy: false}] },
        { name: 'Тройка 2', roles: [{name: 'Клиент', is_busy: true}, {name: 'Интервизор', is_busy: false}] },
        { name: 'Тройка 3', roles: [{name: 'Клиент', is_busy: false}, {name: 'Интервизор', is_busy: false}] },
        { name: 'Тройка 4', roles: [{name: 'Клиент', is_busy: false}, {name: 'Интервизор', is_busy: false}] },
        { name: 'Тройка 5', roles: [{name: 'Клиент', is_busy: true}, {name: 'Интервизор', is_busy: false}] },
        { name: 'Тройка 6', roles: [{name: 'Клиент', is_busy: true}, {name: 'Интервизор', is_busy: false}] }
    ];
    const filtersData = [
        {
            entity: 'Темы',
            meta: 'university_themes',
            items: [
                { id: 1, name: 'Тема 1' },
                { id: 2, name: 'Тема 2' },
                { id: 3, name: 'Тема 3' },
                { id: 4, name: 'Тема 4' },
                { id: 5, name: 'Тема 5' },
                { id: 6, name: 'Тема 6' },
            ]
        },
        {
            entity: 'Роли',
            meta: 'university_roles',
            items: [
                { id: 1, name: 'Группа 1' },
                { id: 2, name: 'Группа 2' },
                { id: 3, name: 'Группа 3' },
                { id: 4, name: 'Группа 4' },
                { id: 5, name: 'Группа 5' },
                { id: 6, name: 'Группа 6' },
            ]
        }
    ];
    let currentFilters = {};

    init();

    function init() {
        renderFilters();
        renderTroikaList();
    }

    function renderFilters() {
        $troikaFiltersContainer.innerHTML = '';

        const itemName = (item) => {
            if (!item) return 'ID unknown';
            return item.name || item.title || (item.first_name || item.last_name ? `${item.first_name || ''} ${item.last_name || ''}`.trim() : item.email) || `ID ${item.id ?? 'unknown'}`;
        };

        filtersData.forEach(filterData => {
            const entityTitle = filterData.entity || filterData.meta || 'Фильтр';
            const metaName = filterData.meta || filterData.entity || 'unknown_meta';
            const itemsRaw = Array.isArray(filterData.items) ? filterData.items : [];

            const items = itemsRaw.map(i => ({
                id: i.id,
                name: itemName(i),
            }));

            const initialValue = Array.isArray(currentFilters[metaName]) ? currentFilters[metaName] : [];

            filter($troikaFiltersContainer, {
                type: 'list',
                filterFor: metaName,
                title: `Все ${entityTitle}`,
                name: entityTitle,
                data: items.length ? items : [],
                value: initialValue,
                modClass: `m-hide`,
                onAccept: (val) => {
                    console.log('Приняли фильтр:', metaName, val);
                },
                onClear: () => {
                    console.log('Сброс фильтра:', metaName);
                },
                onChange: (val) => {
                    console.log('Изменилось:', metaName, val);
                },
            });
        });
    }

    function renderTroikaList() {
        $troikaListContainer.innerHTML = '';
        troikaData.forEach((troika, troikaIndex) => {
            renderTroikaItem(troika, troikaIndex);
        });
    }
    function renderTroikaItem(troika, troikaIndex) {
        const $fragment = $templateTroikaItem.content.cloneNode(true);
        const $troikaRoot = $fragment.querySelector(`.${CLASS_PREFIX}__troikas-item`);
        const $rolesContainer = $fragment.querySelector(`[${DATA_ATTR}-roles]`);
        const $joinButton = $fragment.querySelector(`[${DATA_ATTR}-join]`);

        // для поиска/доступа позже добавим data-атрибут на корневой элемент
        if ($troikaRoot) $troikaRoot.dataset.troikaIndex = troikaIndex;

        troika.roles.forEach((role, roleIndex) => {
            const $role = createRoleElement(role, troikaIndex, roleIndex);
            $rolesContainer.appendChild($role);
        });

        // После создания всех ролей — установим активный (первый доступный)
        const $roleElements = Array.from($rolesContainer.querySelectorAll(`.${CLASS_PREFIX}__troikas-item-control-select`));
        const firstAvailable = $roleElements.find(el => el.dataset.isBusy === 'false');
        if (firstAvailable) {
            setActiveRole($rolesContainer, firstAvailable);
        } else {
            // если все заняты, оставляем без активного — но можно визуально уведомить
            $troikaRoot.classList.add(`${CLASS_PREFIX}__troikas-item--all-busy`);
        }

        // Обработчик кликов по контейнеру ролей (делегирование)
        $rolesContainer.addEventListener('click', (e) => {
            const $target = e.target.closest(`.${CLASS_PREFIX}__troikas-item-control-select`);
            if (!$target) return;
            if ($target.dataset.isBusy === 'true') return; // игнорируем клики по занятым
            setActiveRole($rolesContainer, $target);
        });

        // Присоединиться — действие на кнопку (использует выбранную роль)
        $joinButton.addEventListener('click', () => {
            const $selected = $rolesContainer.querySelector(`.${CLASS_PREFIX}__troikas-item-control-select--active`);
            if (!$selected) {
                // можно показать уведомление, но оставлю простой console
                console.warn('Нет выбранной доступной роли для присоединения.');
                return;
            }
            const troikaIdx = $troikaRoot.dataset.troikaIndex;
            const roleIdx = $selected.dataset.roleIndex;
            const roleName = $selected.dataset.roleName;
            // Пример: вызов API для присоединения
            console.log(`Присоединяемся к тройке ${troikaIdx}, роль ${roleIdx} (${roleName})`);
        });

        $troikaListContainer.appendChild($fragment);
    }
    function createRoleElement(role, troikaIndex, roleIndex) {
        const $role = document.createElement('div');
        $role.classList.add(`${CLASS_PREFIX}__troikas-item-control-select`);
        $role.textContent = role.name;

        // dataset для удобства
        $role.dataset.troikaIndex = troikaIndex;
        $role.dataset.roleIndex = roleIndex;
        $role.dataset.roleName = role.name;
        $role.dataset.isBusy = !!role.is_busy;

        // доступность / внешний вид
        if (role.is_busy) {
            $role.classList.add(`${CLASS_PREFIX}__troikas-item-control-select--disabled`);
            $role.setAttribute('aria-disabled', 'true');
            $role.tabIndex = -1;
        } else {
            $role.tabIndex = 0; // сделать доступным для клавиатуры
            $role.setAttribute('role', 'button');
            $role.setAttribute('aria-pressed', 'false');
        }

        return $role;
    }
    function setActiveRole($rolesContainer, $roleToActivate) {
        // Убираем активность у всех
        const $all = $rolesContainer.querySelectorAll(`.${CLASS_PREFIX}__troikas-item-control-select`);
        $all.forEach(el => {
            el.classList.remove(`${CLASS_PREFIX}__troikas-item-control-select--active`);
            if (el.dataset.isBusy === 'false') el.setAttribute('aria-pressed', 'false');
        });

        // Устанавливаем активность на выбранном
        $roleToActivate.classList.add(`${CLASS_PREFIX}__troikas-item-control-select--active`);
        $roleToActivate.setAttribute('aria-pressed', 'true');
    }
}
